// Module
var code = "<h2 class=\"interiorSectionHeading\"> Schedule a Payment Anytime </h2> <p>You can schedule a payment, target payments, cancel a pending payment, etc.</p> ";
// Exports
export default code;